import singleStemTreeImage from "@/assets/single-stem-tree-image.jpg";

import { getText, interpolate } from "shared/lib";
import {
  TreePropertyType,
  type CircumferenceTreePropertyDescriptor,
  type TreeDescriptor,
} from "@/components/treeModule/lib";

import { Separator } from "shared/components";

export interface SingleStemCircumferenceContentProps {
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function SingleStemCircumferenceContent({
  treeDescriptor,
}: SingleStemCircumferenceContentProps) {
  const circumference = treeDescriptor?.properties.get(
    TreePropertyType.circumference,
  ) as CircumferenceTreePropertyDescriptor | undefined;

  return (
    <div className="text-bodymd text-textPrimary flex w-full flex-wrap gap-4">
      <div className="flex flex-[1_1_300px] flex-col gap-4">
        <p>
          {getText(
            "A tree's measurements help determine if it is protected by the planning scheme or Council's local laws.",
          )}
        </p>

        <Separator orientation="horizontal" />

        <p>
          {getText("To measure a single stem tree:")}
          <ul className="ml-6 list-outside list-disc">
            <li>
              {interpolate(
                "Wrap a tape measure around its trunk at point 'A' to get its circumference. Point 'A' is {{distanceAboveGround}} above ground level, measured along the trunk's length from the closest point above ground level.",
                { distanceAboveGround: circumference?.distanceAboveGround },
              )}
            </li>
            <li>
              {getText(
                "Do the same at point 'B' to measure the circumference at ground level.",
              )}
            </li>
          </ul>
        </p>
      </div>

      <div
        className="h-[300px] max-h-[300px] w-full max-w-[290px] flex-[1_1_200px] rounded"
        style={{
          background: `url(${singleStemTreeImage}) lightgray no-repeat`,
          backgroundPosition: "bottom",
          backgroundSize: "100% auto",
        }}
      />
    </div>
  );
}
